<div class="my-2">
        <a class="d-flex align-items-center justify-content-between recording" href="javascript:void(0)" (click)="playAudio()" *ngIf="playerState == 'stopped'" qid="sPskill-10">
                <div>
                        <p class="recording-heading-1 mb-1">{{ 'LEARNER.ACTIVITYLAUNCH.SUBMITTED_RECORDING' | translate }}</p>
                        <p class="recording-heading-2 mb-0" *ngIf="audioDuration">{{ 'LEARNER.ACTIVITYLAUNCH.PLAY_RECORDING_MSG2' | translate:{elapsedTime: audioDuration} }}</p>
                </div>
                <div class="icon-wrapper play-btn {{segment}} rounded-circle d-flex align-items-center justify-content-center">
                        <i class="fa fa-play" aria-hidden="true"></i>
                </div>
        </a>

        <a class="d-flex align-items-center justify-content-between recording" href="javascript:void(0)" (click)="stopPlayingAudio()" *ngIf="playerState == 'playing'" qid="sPskill-11">
                <div>
                        <p class="recording-heading-1 mb-1 red-heading">{{ 'LEARNER.ACTIVITYLAUNCH.STOP_PLAYING_MSG1' | translate }}</p>
                        <p class="recording-heading-2 mb-0 red-heading" *ngIf='audioDuration'>{{ 'LEARNER.ACTIVITYLAUNCH.STOP_PLAYING_MSG2' | translate:{audioSeeker: audioSeeker, duration: audioDuration } }}</p>
                </div>
                <div class="icon-wrapper outer-circle rounded-circle d-flex align-items-center justify-content-center">
                        <div class="inner-circle rounded-circle d-flex align-items-center justify-content-center">
                                <i class="fa fa-stop" aria-hidden="true"></i>
                        </div>
                </div>
        </a>
</div>